import { theme } from "@/core/theme";
import Group from "@/tpo/Group";

import DashboardSections from "./DashboardSections";
import NavigationInstance from "./Navigation";
import {
  dashboardPageMaxWidth,
  learningHubDashboardSidebarContentFlexDirection,
  learningHubDashboardSidebarContentGap,
  learningHubDashboardMainLayoutPb,
  learningHubDashboardMainLayoutPt,
  learningHubDashboardMainLayoutPx,
  learningHubDashboardSidebarDesktopMinWidth,
  lhDashboardBp
} from "./dashboardLayout";

export default function Dashboard() {
  return (
    <Group
      flexDirection={learningHubDashboardSidebarContentFlexDirection}
      justifyContent="center"
      pt={learningHubDashboardMainLayoutPt}
      pb={learningHubDashboardMainLayoutPb}
      px={learningHubDashboardMainLayoutPx}
      maxWidth={dashboardPageMaxWidth}
      mx="auto"
      width="100%"
      gap={learningHubDashboardSidebarContentGap}
    >
      <NavigationInstance
        desktopMinWidth={learningHubDashboardSidebarDesktopMinWidth}
        mobileNavMenuMaxWidthFrom={theme.breakpoints.md}
        mobileDropdownProps={{ maxWidth: lhDashboardBp(null, 353, 353) }}
      />
      <DashboardSections />
    </Group>
  );
}
